import React from "react";
import { Page } from "../Page";
import { api } from "../../api/api";
import { ref } from "../../types";
import { Table } from "../../core/ui/Table";
import { ConditionalController, useConditional } from "../../core/hooks/useConditional";
import { Modal } from "../../core/ui/Modal";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { Text } from "../../core/form/Text";
import { EditableTable } from "../../core/ui/EditableTable";
import { CopyToClipboardCol, IDCol, LastUpdatedCol, SyncTableCol, TitleCol, VersionCol } from "../../layout/TableCells";
import { newID } from "../../core/utils/unique";
import { FormModal } from "../../data-entry/FormModal";


export function EditModal(props: {
	item: ref,
	controller: ConditionalController<any>,

	onSave: () => void,
	onDelete: () => void,
}) {

	const data = useDataContext({ initialValue: props.item });

	return (
		<DataContext.Provider value={data}>
			<Modal
				title="Edit Reference Table"
				onCancel={props.controller.close}
				onSave={props.onSave}
				saveOnEnterKey={false}
				showDelete={true}
				onDelete={props.onDelete}
			>

				<fieldset className="width-100pc">
					<Text prop="id" title="ID" />
					<Text prop="title" title="Title" />
				</fieldset>

				<EditableTable
					data={props.item.data}
				/>

			</Modal>
		</DataContext.Provider>
	)

}


export function Ref(props: {

}) {

	const [refs, setRefs] = React.useState<ref[]>();
	const [token, setToken] = React.useState("");

	React.useEffect(() => {
		api.ref_get({}).then((refs: ref[]) => {
			refs.sort((a, b) => {
				return (a ? a.title : "").localeCompare(b ? b.title : "");
			});

			setRefs(refs as ref[]);

		}).catch(() => {

		});
	}, [token]);

	const edit = useConditional((r: ref) => {
		return (
			<EditModal
				item={r}
				controller={edit}

				onSave={() => {
					api.ref_post(r).then((result: any) => {
						if (result.id && !r.id) r.id = result.id;

						edit.close();
					}).catch(() => {

					});
				}}
				onDelete={() => {
					api.ref_delete(r).then((result: any) => {
						if (refs) {
							const items = refs.slice(0);
							for(let i=0;i<items.length;i++) {
								if (items[i] === r) {
									items.splice(i, 1);
									setRefs(items);
									break;
								}
							}	
						}

						edit.close();
					}).catch(() => {

					});
				}}
			/>
		)
	});

	const createModal = useConditional(() => {
		return (
			<FormModal
				title="Create Reference Table"
				form="ref-create"
				onCancel={createModal.close}
				onSave={(value: ref) => {

					const r = {
						...value,
						deleted: 0,

						data: {
							columns: [{
								id: "0",
								title: "ID"
							}],
							rows: [{
								"0": "",
							}],
						},
					}

					api.ref_post(r).then(() => {
						setToken(newID());
						createModal.close();
					}).catch(() => {
	
					});	
				}}
			/>
		)
	});

	if (!refs) {
		return null;
	}
	
	return (
		<Page
			compact={true}
			title={{
				text: "Reference Tables",
				icon: "reference_color",
				buttons: [
					{ title: "Create" }
				]
			}}
			onButton={(btn) => {
				createModal.show({});
			}}
		>

			<Table
				interactive={true}
				cols={[
					VersionCol(),
					IDCol(),
					TitleCol(),
					LastUpdatedCol(),
					SyncTableCol({ container: "ref", onSync: () => {
						setToken(newID());
					} }),
					CopyToClipboardCol(),
				]}
				items={refs}
				onClick={(e, r) => {
					if (r) {
						edit.show(r);
					}
				}}
			/>

			{edit.render()}
			{createModal.render()}

		</Page>
	);
}